import { TasksFilterQueryParamsV2 } from "@fartherfinance/frontend/api/Tasks/requests/getTasks.v2";
import { TaskPriority } from "@fartherfinance/frontend/api/Tasks/Types";

import { TASKS_DEFAULT_QUERY_PARAMS } from "../common";

type TaskQuickFilter<T> = {
  label: string;
  filterKey: Array<keyof TasksFilterQueryParamsV2>;
  filterValue: T | undefined;
};

export const myTasksQuickFilter: TaskQuickFilter<undefined> = {
  label: "My Tasks",
  filterKey: ["filterByPersonAssignee"],
  filterValue: undefined,
};

export const highPriorityQuickFilter: TaskQuickFilter<TaskPriority[]> = {
  label: "High Priority",
  filterKey: ["filterByTaskPriority"],
  filterValue: TASKS_DEFAULT_QUERY_PARAMS.filterByTaskPriority,
};

export const dueTodayQuickFilter: TaskQuickFilter<undefined> = {
  label: "Due Today",
  filterKey: ["filterByDueDateAfter", "filterByDueDateBefore"],
  filterValue: undefined,
};
